import React, { useState } from 'react';
import { Button } from './ui/button';
import { ChangeCustomerDialog } from './ChangeCustomerDialog';
import { hasBoundQuote } from './attachedCustomer';

/* The attached-customer row the Application and Quote pages both show (UND-987): the customer's name
   plus a Change control that opens ChangeCustomerDialog, hidden once any of the application's quotes
   has bound — see attachedCustomer.js's hasBoundQuote for exactly which quotes count.

   `onChanged` is the host's own refresh — every caller reloads the application the same way a loss-grid
   save does (`refreshApplicationData(true)`), since the customer change touches the application, its
   quotes and the Skyward rows the loss grid reads through them. */
const CustomerAttachment = ({ application, onChanged }) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  if (!application) {
    return null;
  }

  const { customer, quotes } = application;
  const canChange = !hasBoundQuote(quotes);

  return (
    <div className="flex flex-row items-center gap-3">
      <span className="max-w-full truncate text-base font-bold text-foreground">{customer ? customer.name : 'No customer attached'}</span>
      {canChange ? (
        <Button variant="outline" size="sm" onClick={() => setDialogOpen(true)}>
          Change
        </Button>
      ) : null}
      <ChangeCustomerDialog open={dialogOpen} application={application} onClose={() => setDialogOpen(false)} onChanged={onChanged} />
    </div>
  );
};

export { CustomerAttachment };
